module.exports = __webpack_public_path__ + "src/assets/images/close-btn.png?e3a035cb30aba35bbc0fdfe3956a953a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close-btn.png
// module id = 988
// module chunks = 1